"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAlignment = void 0;
exports.FormFieldHelper = FormFieldHelper;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let EAlignment = exports.EAlignment = /*#__PURE__*/function (EAlignment) {
  EAlignment["Center"] = "center";
  EAlignment["Left"] = "left";
  EAlignment["Right"] = "right";
  return EAlignment;
}({});
function FormFieldHelper(props) {
  const {
    alignment = EAlignment.Left,
    marginBottom = false
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['cont'], {
      [styles['align-center']]: alignment === EAlignment.Center,
      [styles['align-left']]: alignment === EAlignment.Left,
      [styles['align-right']]: alignment === EAlignment.Right,
      [styles['margin-bottom']]: marginBottom
    })
  }, props.children);
}